import MarketoSelect from '@/features/MarketoForm/Controls/SelectControl/MarketoSelect';
import MarketoAutocomplete from '@/features/MarketoForm/Controls/MarketoAutocomplete';
import React, { memo } from 'react';

const MAX_OPTIONS_FOR_AUTOCOMPLETE = 50;

interface SelectControlProps {
  classes: any;
  error: string;
  disabled: boolean;
  attributes: any;
  label: string;
  value: any;
  onChange: (event: any) => void;
  onChangeAutocomplete: (event: any, value: any) => void;
  selectIconClassName: string;
  options: any[];
}

const MarketoSelectControl = ({
  classes,
  error,
  disabled,
  attributes,
  label,
  value,
  onChange,
  onChangeAutocomplete,
  selectIconClassName,
  options,
}: SelectControlProps) => {
  return options.length < MAX_OPTIONS_FOR_AUTOCOMPLETE ? (
    <MarketoSelect
      classes={classes}
      error={error}
      disabled={disabled}
      attributes={attributes}
      label={label}
      value={value}
      onChange={onChange}
      selectIconClassName={selectIconClassName}
      options={options}
    />
  ) : (
    <MarketoAutocomplete
      classes={classes}
      error={error}
      disabled={disabled}
      attributes={attributes}
      label={label}
      value={value}
      onChange={onChangeAutocomplete}
      selectIconClassName={selectIconClassName}
      options={options}
    />
  );
};

export default memo(MarketoSelectControl);
